// Necessary imports
import React from "react";
import i4 from "../components/Styles/assets/Graphics/dental.webp";

import img2 from "../components/Styles/assets/Graphics/DentalClient2.webp";
import img4 from "../components/Styles/assets/Graphics/DentalClient4.webp";
import img9 from "../components/Styles/assets/Graphics/DentalClient9.webp";
import img7 from "../components/Styles/assets/Graphics/DentalClient7.webp";
import img3 from "../components/Styles/assets/Graphics/DentalClient3.webp";
import img5 from "../components/Styles/assets/Graphics/DentalClient5.webp";
import img6 from "../components/Styles/assets/Graphics/DentalClient6.webp";
import img8 from "../components/Styles/assets/Graphics/DentalClient8.webp";



import {
  StyledHCard,
  StyledClient
} from "../components/Styles";

import Consultation from "../components/Consultation";
import ClientHorizontalCard from "../components/ClientHorizontalCard";

import { useTranslation } from "react-i18next";

const iconMapping = {
  card1: img4,
  card2: img9,
  card3: img3,
  card4: img5,
  card5: img7,
  card6: img6,
  card7: img8,
  card8: img2,
};

const Dental = () => {
  const { t, i18n } = useTranslation();

  const cards = [
    "card1",
    "card2",
    "card3",
    "card4",
    "card5",
    "card6",
    "card7",
    "card8"
  ];

  return (
    <StyledClient.Container>
      <StyledClient.Content>
        <StyledClient.ShapeTopLeft>
          <img src={i4} alt="Icon" />
        </StyledClient.ShapeTopLeft>

        <StyledClient.Title>
          {t("dental.title")}
        </StyledClient.Title>

        <StyledClient.Description>
          {t("dental.description")}
        </StyledClient.Description>
      </StyledClient.Content>

      <Consultation />

      <StyledClient.H3 lang={i18n.language}>{t("dental.servicesTitle")}</StyledClient.H3>

      {cards.map((key, index) => (
        <ClientHorizontalCard
          key={index}
          title={t(`dental.cards.${key}.title`)}
          subtitle={t(`dental.cards.${key}.subtitle`)}
          visionPoints={t(`dental.cards.${key}.visionPoints`, { returnObjects: true })}
          missionPoints={t(`dental.cards.${key}.missionPoints`, { returnObjects: true })}
          icon={iconMapping[key]}
        />
      ))}

      <StyledHCard.Container />
      <Consultation />
    </StyledClient.Container>
  );
};

export default Dental;